<template>
  <div
    ref="root"
    class="ui-dialog-content modal-content rounded-4 overflow-hidden"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";
import { useUIDialogContext } from "./UIDialogRoot.vue";

const root = ref<HTMLElement>();
const dialog = useUIDialogContext();

onClickOutside(root, () => dialog?.dismiss(), {
  ignore: [
    ".vs__dropdown-menu",
    ".vs__dropdown-option",
    ".vs__dropdown-toggle",
    ".vs__actions",
    ".vs__search",
  ],
  // fire early so the ignore works before any bubbling close handlers
  capture: true,
  // guard against touch/mouse differences
  events: ["pointerdown", "mousedown", "touchstart"],
});
</script>
